/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { array } from 'prop-types'
import { css } from '@emotion/react'
import { Link } from 'gatsby'
import { URLS, PRODUCT_SUITES } from '../../constants'
import Icon from '../Icon'

const productSuiteListCss = (theme) => css`
  margin-bottom: 45px;

  a {
    &:hover {
      > div p {
        color: ${theme.colors.blue600};
      }
    }

    svg {
      max-width: 20px;
      max-height: 20px;
      position: relative;
      top: -13px;
      margin-right: 10px;
    }

    > div {
      p {
        display: block;
        font-size: 16px;
        line-height: 16px;
        font-weight: ${theme.font.bold};
        margin: 0;
      }

      span {
        font-size: 13px;
        color: ${theme.colors.gray600};
        white-space: nowrap;
      }
    }
  }
`

export const productSuites = PRODUCT_SUITES.filter(
  (item) => item.label !== URLS.LIVECHAT.LABEL
)

const ProductSuites = ({ products = productSuites, ...rest }) => (
  <div css={productSuiteListCss} {...rest}>
    {products.map((item) => (
      <Link key={`suite-${item.label}`} to={item.appPath}>
        <Icon label={item.label} />

        <div>
          <p>{item.label}</p>
          <span>{item.description}</span>
        </div>
      </Link>
    ))}
  </div>
)

ProductSuites.propTypes = {
  products: array,
}

export default ProductSuites
